export { default as IconCell } from './IconCell'
export type { IconCellProps } from './IconCell.types'
